
import { Component, Vue, Watch } from "vue-property-decorator";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import TableHeader from "./TableHeader.vue";
import dayjs from "dayjs";
import { LogHelper } from "@/common/LogHelper";

import {
  lookUpBaseData,
  uploadBaseData,
  bigNumberCheck,
  customRuleSearch,
  query,
  osdInfoDownLoad,
  queryNewBagRulesCount,
} from "@/api/service";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "scanforsealcar",
  components: {
    YtoTable,
    TableHeader,
  },
})
export default class extends Vue {
  public downloadDialogVisible = false;
  public downloadTitle = "";
  public downloadContent = "";
  public queryForm = true;
  public downloadState = "准备下载";
  public progressValue = 0;
  public nCurrentBaseDataType = 0;
  public bIsSuccess = false;
  public bIsEndUpload = false;
  public bValue = 0;

  public queryDialogVisible = false;
  public queryDialogVisible11 = false;
  public queryDialogVisible12 = false;
  public queryTitle = "";
  public queryLabel = "";
  public queryString = "";
  public bigNumDataShow = false;
  public bigNumDataResult = "查询结果";
  public queryPaginationTotal = 0;
  public queryPaginationCurrentPage = 1;
  public dicRet = []; //保存一键修复的结果

  public oneKeyRepaireTitle = "";
  public oneKeyRepaireDialogVisible = false;
  public oneKeyRepaireForm = true;
  public oneKeyRepaireContent = "";
  public oneKeyRepaireState = "";
  public oneKeyRepaireTableData = [];

  public resultText = "";
  public timer;
  public globalConfig: any = {};
  public nTotalScanNum = 0;
  public tableData = [];
  public tableQueryData = [];
  public isNewBagRules = false;

  get BagRuleTableName() {
    return this.isNewBagRules ? "T_EXP_BAG_RULE_V1" : "T_EXP_BAG_RULE";
  }

  get BagRuleTableColumns() {
    return this.isNewBagRules ? ["PACKAGEFIRSTCODE", "OPENPACKAGEORG", "BUILDPACKAGENAME"] : ["DESTORGCODE","PACKAGEORGCODE","BUILDPAGENAME"];
  }

  public repairfunc() {
    this.oneKeyRepaireDialogVisible = true;
    this.oneKeyRepaireTitle = "一键修复";
    this.oneKeyRepaireContent = "确认重新下载所有数据";
    this.nCurrentBaseDataType = 0;
    this.oneKeyRepaireForm = true;
  }
  public clearResultFunc() {
    this.bigNumDataResult = "查询结果";
  }
  mounted() {
    this.globalConfig = SystemConfigModule.globalData;
    this.InitData1();
    this.InitData2();
    this.InitData3();
    this.InitData4();
    this.InitData5();
    this.InitData6();
    this.InitData7();
    this.InitData8();
    this.InitData9();
    this.InitData10();
    this.InitData11();
    this.InitData12();
  }
  private OneKeyRepaireConfirm() {
    LogHelper.WriteLog("一键修复");
    this.oneKeyRepaireState = "下载中";
    this.oneKeyRepaireForm = false;
    this.oneKeyRepaireTableData = [];
    this.oneKeyRepaireTableData.push({
      no: 1,
      job: "下载条码规则",
      result: "",
    });
    this.oneKeyRepaireTableData.push({ no: 2, job: "下载大号段", result: "" });
    this.oneKeyRepaireTableData.push({
      no: 3,
      job: "下载特殊不校验规则",
      result: "",
    });
    this.oneKeyRepaireTableData.push({
      no: 4,
      job: "下载业务规则",
      result: "",
    });
    this.oneKeyRepaireTableData.push({
      no: 5,
      job: "下载组织建包规则",
      result: "",
    });
    this.oneKeyRepaireTableData.push({ no: 6, job: "下载员工", result: "" });
    this.oneKeyRepaireTableData.push({
      no: 7,
      job: "下载网点/中心(组织)",
      result: "",
    });
    this.oneKeyRepaireTableData.push({ no: 8, job: "下载线路", result: "" });
    this.oneKeyRepaireTableData.push({
      no: 9,
      job: "下载问题件大类",
      result: "",
    });
    this.oneKeyRepaireTableData.push({
      no: 10,
      job: "下载问题件小类",
      result: "",
    });
    this.oneKeyRepaireTableData.push({
      no: 11,
      job: "下载自定义条码规则",
      result: "",
    });
    this.oneKeyRepaireTableData.push({
      no: 12,
      job: "下载OSD信息",
      result: "",
    });

    setTimeout(() => {
      this.OneClickRepair();
    }, 300);
  }
  private InitData1() {
    try {
      //1、条码规则
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_RULE_THIRD",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "1",
        dataType: "条码规则",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "不支持查看明细",
        download: "下载",
        disable: true,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData2() {
    try {
      //2、大号段
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "1",
          columns: "*",
          tableName: "t_exp_material_compress",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      let _model = {
        no: "2",
        dataType: "大号段",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "校验单号",
        download: "下载",
        disable: false,
      };

      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData3() {
    try {
      //3、特殊不校验
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "1",
          columns: "*",
          tableName: "t_exp_waybill_special",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model3 = {
        no: "3",
        dataType: "特殊不校验规则",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "不支持查看明细",
        download: "下载",
        disable: true,
      };
      if (response.respcode == "000") {
        _model3.downloadedNum = response.data.busiData.total;
      } else {
        _model3.downloadedNum = "下载失败";
      }
      this.tableData.push(_model3);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData4() {
    try {
      //4、业务规则
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_ORG_BUSINESS_RULE",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "4",
        dataType: "业务规则",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData5() {
    this.setIsNewBagRules();

    try {
      //5、组织建包规则
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "1",
          columns: "*",
          tableName: this.BagRuleTableName,
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "5",
        dataType: "组织建包规则",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }

  private setIsNewBagRules() {
    try {
      const response = JSON.parse(queryNewBagRulesCount());
      if (response.respcode == "000") {
        this.isNewBagRules = response.data.count > 0;
      } else {
        this.isNewBagRules = false;
      }
    } catch (error) {
      this.isNewBagRules = false;
      LogHelper.Error(error);
    }
  }

  private InitData6() {
    try {
      //6、员工
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_EMPLOYEE",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "6",
        dataType: "员工",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData7() {
    try {
      //7、组织
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_ORG_INFO",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "7",
        dataType: "网点/中心（组织）",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData8() {
    try {
      //8、线路
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_LINE",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "8",
        dataType: "线路",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData9() {
    try {
      //9、问题件大类
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_BIG_PRIOBLEM_INFO",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "9",
        dataType: "问题件大类",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData10() {
    try {
      //10、问题件大类
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "2",
          columns: "*",
          tableName: "T_EXP_SMALL_PROBLEM_INFO",
          condition: "",
          descs: "",
          ascs: "",
          current: "",
          size: "",
        },
      };
      let response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
      LogHelper.WriteLog(response);
      let _model = {
        no: "10",
        dataType: "问题件小类",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response.respcode == "000") {
        _model.downloadedNum = response.data.busiData.total;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData11() {
    try {
      //11、自定义拦截规则
      let _response = customRuleSearch(
        this.globalConfig.LocalMac,
        this.globalConfig.CompName,
        this.globalConfig.CurrentDeviceType,
        this.globalConfig.InOutFlag
      );
      let response = _response == null ? null : JSON.parse(_response);
      LogHelper.WriteLog(response);
      let _model = {
        no: "11",
        dataType: "自定义拦截规则",
        downloadedNum: "2",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      if (response != null) {
        _model.downloadedNum = response.length;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private InitData12() {
    try {
      //12、OSD
      let response = JSON.parse(osdInfoDownLoad(""));
      LogHelper.WriteLog(response);
      let _model = {
        no: "12",
        dataType: "OSD信息",
        downloadedNum: "0",
        lastestDownloadTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        operation: "查看明细",
        download: "下载",
        disable: false,
      };
      debugger;
      if (response.respcode == "000") {
        _model.downloadedNum = response.data?.count;
      } else {
        _model.downloadedNum = "下载失败";
      }
      this.tableData.push(_model);
    } catch (error) {
      LogHelper.Error(error);
    }
  }
  private QueryClick(row) {
    this.bigNumDataShow = false;
    switch (row.no) {
      case "1":
        break;
      case "2":
        this.queryTitle = "大号段校验";
        this.queryLabel = "运单号：";
        this.bigNumDataShow = true;
        break;
      case "3":
        break;
      case "4":
        this.queryTitle = "业务规则下载明细查询";
        this.queryLabel = "业务规则名称：";
        break;
      case "5":
        this.setIsNewBagRules();
        this.queryTitle = "组织建包规则下载明细查询";
        this.queryLabel = `${this.isNewBagRules ? "包签码" : "目的地"}/拆包地代码/包名称：`;
        break;
      case "6":
        this.queryTitle = "员工下载明细查询";
        this.queryLabel = "员工工号/姓名：";
        break;
      case "7":
        this.queryTitle = "网点/中心(组织)下载明细查询";
        this.queryLabel = "组织代码/名称：";
        break;
      case "8":
        this.queryTitle = "线路下载明细查询";
        this.queryLabel = "线路编码/名称：";
        break;
      case "9":
        this.queryTitle = "问题件大类下载明细查询";
        this.queryLabel = "代码/名称：";
        break;
      case "10":
        this.queryTitle = "问题件小类下载明细查询";
        this.queryLabel = "代码/名称：";
        break;
      case "11":
        this.queryTitle = "自定义拦截件规则明细查询";
        this.queryLabel = "前缀：";

        this.queryDialogVisible11 = true;
        this.nCurrentBaseDataType = parseInt(row.no);
        this.SearchData();
        LogHelper.WriteLog(row);
        return;
      case "12":
        this.queryTitle = "OSD明细查询";
        this.queryLabel = "OSD信息：";
        this.queryDialogVisible12 = true;
        this.nCurrentBaseDataType = parseInt(row.no);
        this.SearchData();
        LogHelper.WriteLog(row);
        return;
      default:
        break;
    }
    this.queryDialogVisible = true;
    this.nCurrentBaseDataType = parseInt(row.no);
    this.SearchData();
    LogHelper.WriteLog(row);
  }
  private queryLabelInputFunc() {
    this.SearchData();
  }
  private QueryFunc() {
    this.SearchData();
    this.queryPaginationCurrentPage = 1;
  }
  public SearchData(nCurrentPage = 0) {
    debugger;

    let strCondition = "";
    let _nCurrentBaseDataType = this.nCurrentBaseDataType - 1;
    switch (_nCurrentBaseDataType) {
      case 1:
        this.InitBigNumData(this.queryString);
        break;
      case 2:
        break;
      case 3:
        strCondition = "name like '%" + this.queryString + "%'";
        this.InitBusinessRuleData(strCondition, nCurrentPage);
        break;
      case 4:
        strCondition =
          this.BagRuleTableColumns.map((column) => `${column} like '%${this.queryString}%'`).join(" or ");
        this.InitOrgPackageRule(strCondition, nCurrentPage);
        break;
      case 5:
        strCondition =
          "code like '%" +
          this.queryString +
          "%' or name like '%" +
          this.queryString +
          "%'";
        this.InitEmployeeData(strCondition, nCurrentPage);
        break;
      case 6:
        strCondition =
          "code like '%" +
          this.queryString +
          "%' or name like '%" +
          this.queryString +
          "%'";
        this.InitOrgInfoData(strCondition, nCurrentPage);
        break;
      case 7:
        strCondition =
          "lineNo like '%" +
          this.queryString +
          "%' or lineName like '%" +
          this.queryString +
          "%'";
        this.InitLineInfoData(strCondition, nCurrentPage);
        break;
      case 8:
        strCondition =
          "bigCode like '%" +
          this.queryString +
          "%' or bigName like '%" +
          this.queryString +
          "%'";
        this.InitBigProblemData(strCondition, nCurrentPage);
        break;
      case 9:
        strCondition =
          "smallCode like '%" +
          this.queryString +
          "%' or smallTemplete like '%" +
          this.queryString +
          "%'";
        this.InitSmallProblemData(strCondition, nCurrentPage);
        break;
      case 10:
        this.InitCustomRuleSearchData(strCondition, nCurrentPage);
        break;
      case 11:
        this.InitOSDData(strCondition, nCurrentPage);
        break;
      default:
        break;
    }
  }
  private queryDialogCloseFunc() {
    setTimeout(() => {
      this.bigNumDataResult = "查询结果";
      this.queryString = "";
      this.tableQueryData = [];
      this.queryPaginationCurrentPage = 1;
      this.queryPaginationTotal = 0;
    }, 200);
  }

  /// <summary>
  /// 大号段数据下载查询
  /// </summary>
  /// <param name="strCondition"></param>
  private InitBigNumData(strCondition) {
    debugger;

    if (strCondition == null || strCondition.length == 0) {
      return;
    }
    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        queryValue: strCondition,
        queryType: "24",
        viewType: "",
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };

    var response = JSON.parse(bigNumberCheck(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      this.bigNumDataResult = response.data.extend2;
    }
  }
  /// <summary>
  /// 业务规则下载明细查询
  /// </summary>
  /// <param name="strCondition"></param>
  private InitBusinessRuleData(strCondition, nCurrent) {
    this.tableQueryData = [];

    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "2",
        columns: "name,value,feedback",
        tableName: "T_EXP_ORG_BUSINESS_RULE",
        condition:
          strCondition == null || strCondition == undefined ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
      this.SearchFailRet();
    } else {
      let jsData = response.data.busiData;
      this.queryPaginationTotal = jsData.total;
      debugger;
      // // let pages = parseInt(jsData.pages.ToString());
      // // ShowPages();
      let str = jsData.records;
      let jArray = str;
      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        debugger;
        let jdata = item;
        let strName = "",
          strValue = "",
          strFeedBack = "";
        if (jdata.name != null) {
          strName = jdata.name.toString();
        }
        if (null != jdata.value) {
          strValue = jdata.value.toString();
        }
        if (jdata.feedback != null) {
          strFeedBack = jdata.feedback.toString();
        }
        let strRet = "";
        // // Value = nCount.toString();
        if (strValue == "true" || strValue == "false") {
          if (strValue == "true") {
            strRet = "是 / ";
          } else {
            strRet = "否 / ";
          }
          if (
            !(
              strFeedBack == undefined ||
              strFeedBack == null ||
              strFeedBack.length == 0
            )
          ) {
            if (strFeedBack == "LABEL") {
              strRet += "阻塞";
            } else if (strFeedBack == "ALERT") {
              strRet += "静默";
            } else if (strFeedBack == "COMFIRM") {
              strRet += "询问";
            }
          } else {
            strRet = strRet.replace("/", "");
          }
        }
        let sValue = strRet.length == 0 ? strValue : strRet;
        this.tableQueryData.push({
          no: nCount,
          content: strName + "：" + sValue,
        });
        nCount++;
      });
    }
  }
  /// <summary>
  /// 组织建包规则下载明细查询
  /// </summary>
  /// <param name="strCondition"></param>
  public InitOrgPackageRule(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];

    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "1",
        columns: this.BagRuleTableColumns.join(","),
        tableName: this.BagRuleTableName,
        condition: strCondition == null ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "10",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      let jsData = response.data.busiData;
      // pages = parseInt(jsData.pages.toString());
      let str = jsData.list;
      let jArray = str;
      debugger;
      this.queryPaginationTotal = jsData.total;

      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        this.tableQueryData.push({
          no: nCount,
          content: this.BagRuleTableColumns.map((column) => item[column] != null ? item[column].toString() : "").join("："),
        });

        nCount++;
      });
    }
  }
  /// <summary>
  /// 员工信息下载查询
  /// </summary>
  /// <param name="strCondition"></param>
  public InitEmployeeData(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];

    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "2",
        columns: "code,name",
        tableName: "T_EXP_EMPLOYEE",
        condition: strCondition == null ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      let jsData = response.data.busiData;
      // pages = int.Parse(jsData["pages"].ToString());
      // ShowPages();
      let str = jsData.records;
      let jArray = str;
      this.queryPaginationTotal = jsData.total;

      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        let jdata = item;
        let strCode = "",
          strName = "";
        if (jdata.code != null) {
          strCode = jdata.code.toString();
        }
        if (jdata.name != null) {
          strName = jdata.name.toString();
        }
        this.tableQueryData.push({
          no: nCount,
          content: strCode + "：" + strName,
        });
        nCount++;
      });
    }
  }
  /// <summary>
  /// 网点、中心（组织）下载明细查询
  /// </summary>
  public InitOrgInfoData(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];
    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "2",
        columns: "code,name",
        tableName: "T_EXP_ORG_INFO",
        condition: strCondition == null ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      let jsData = response.data.busiData;
      // pages = int.Parse(jsData["pages"].ToString());
      // ShowPages();
      let str = jsData.records;
      let jArray = str;
      this.queryPaginationTotal = jsData.total;

      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        let jdata = item;

        let strCode = "",
          strName = "";
        if (jdata.code != null) {
          strCode = jdata.code.toString();
        }
        if (jdata.name != null) {
          strName = jdata.name.toString();
        }
        this.tableQueryData.push({
          no: nCount,
          content: strCode + "：" + strName,
        });

        nCount++;
      });
    }
  }

  /// <summary>
  /// 线路下载明细查询
  /// </summary>
  public InitLineInfoData(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];
    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "2",
        columns: "lineNo,lineName",
        tableName: "T_EXP_LINE",
        condition: strCondition == null ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      let jsData = response.data.busiData;

      // pages = parseInt(jsData.pages);
      // ShowPages();

      let str = jsData.records;
      let jArray = str;
      this.queryPaginationTotal = jsData.total;
      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        // DataGridViewRow row = new DataGridViewRow();
        // int index = dataGridView1.Rows.Add(row);
        let jdata = item;
        let strLineNo = "",
          strLineName = "";
        if (jdata.lineNo != null) {
          strLineNo = jdata.lineNo.toString();
        }
        if (jdata.lineName != null) {
          strLineName = jdata.lineName.toString();
        }
        this.tableQueryData.push({
          no: nCount,
          content: strLineNo + "：" + strLineName,
        });
        nCount++;
      });
    }
  }

  /// <summary>
  /// 问题件大类下载明细查询
  /// </summary>
  public InitBigProblemData(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];
    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "2",
        columns: "bigCode,bigName",
        tableName: "T_EXP_BIG_PRIOBLEM_INFO",
        condition: strCondition == null ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      let jsData = response.data.busiData;
      // pages = int.Parse(jsData["pages"].ToString());
      // ShowPages();
      let str = jsData.records;
      let jArray = str;
      this.queryPaginationTotal = jsData.total;
      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        let jdata = item;
        let strBigCode = "",
          strBigName = "";
        if (jdata.bigCode != null) {
          strBigCode = jdata.bigCode.toString();
        }
        if (jdata.bigName != null) {
          strBigName = jdata.bigName.toString();
        }
        this.tableQueryData.push({
          no: nCount,
          content: strBigCode + "：" + strBigName,
        });
        nCount++;
      });
    }
  }
  /// <summary>
  /// 问题件小类下载明细查询
  /// </summary>
  /// <param name="strCondition"></param>
  public InitSmallProblemData(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];

    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        dbType: "2",
        columns: "smallCode,smallTemplete",
        tableName: "T_EXP_SMALL_PROBLEM_INFO",
        condition: strCondition == null ? "" : strCondition,
        descs: "",
        ascs: "",
        current: nCurrent == 0 ? "" : nCurrent.toString(),
        size: "",
      },
    };
    var response = JSON.parse(lookUpBaseData(JSON.stringify(request)));
    if (response.respcode != "000") {
      LogHelper.WriteLog("查询失败" + response.respMessage);
    } else {
      let jsData = response.data.busiData;
      this.queryPaginationTotal = jsData.total;

      // pages = int.Parse(jsData["pages"].ToString());
      // ShowPages();

      let str = jsData.records;
      let jArray = str;
      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        let jdata = item;

        let strSmallCode = "",
          strSmallTemplete = "";
        if (jdata.smallCode != null) {
          strSmallCode = jdata.smallCode.toString();
        }
        if (jdata.smallTemplete != null) {
          strSmallTemplete = jdata.smallTemplete.toString();
        }
        this.tableQueryData.push({
          no: nCount,
          content: strSmallCode + "：" + strSmallTemplete,
        });
        nCount++;
      });
    }
  }
  /// <summary>
  /// 自定义条码规则下载明细查询
  /// </summary>
  /// <param name="strCondition"></param>
  public InitCustomRuleSearchData(strCondition = "", nCurrent = 0) {
    this.tableQueryData = [];
    let _response = customRuleSearch(
      this.globalConfig.LocalMac,
      this.globalConfig.CompName,
      this.globalConfig.CurrentDeviceType,
      this.globalConfig.InOutFlag
    );
    let response = _response == null ? null : JSON.parse(_response);
    if (response == null) {
      LogHelper.WriteLog("自定义条码规则查询失败");
    } else {
      let jArray = response;
      let nCount = nCurrent == 0 ? 1 : (nCurrent - 1) * 10 + 1;
      jArray.forEach((item) => {
        let jdata = item;
        if (this.queryString.length > 0) {
          if (
            jdata.prefix != null &&
            jdata.prefix != undefined &&
            jdata.prefix.indexOf(this.queryString.toUpperCase()) != -1
          ) {
            this.tableQueryData.push({
              no: nCount,
              prefix: jdata.prefix,
              scanLength: jdata.scanLength,
              failureTime: jdata.failureTime,
            });
            nCount++;
          }
        } else {
          this.tableQueryData.push({
            no: nCount,
            prefix: jdata.prefix,
            scanLength: jdata.scanLength,
            failureTime: jdata.failureTime,
          });
          nCount++;
        }
      });
    }
  }

  /// <summary>
  /// OSD下载明细查询
  /// </summary>
  /// <param name="strCondition"></param>
  public InitOSDData(strCondition = "", nCurrent = 0) {
    debugger;
    this.tableQueryData = [];
    let request = {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        queryValue: "",
        queryType: "36",
        viewType: "",
        extend1: "",
        extend2: "",
        extend3: "",
      },
    };
    let response = JSON.parse(query(JSON.stringify(request)));

    if (response == null || response.respcode != "000") {
      LogHelper.WriteLog("OSD查询失败");
    } else {
      let jArray = response.data;
      let nCount = 1;
      var _tabledata = [];
      jArray.forEach((item) => {
        let jdata = item;
        if (this.queryString.length > 0) {
          if (
            jdata.ip != null &&
            jdata.ip != undefined &&
            jdata.ip.indexOf(this.queryString.toUpperCase()) != -1
          ) {
            _tabledata.push({
              OSD_no: nCount,
              OSD_cameraOrgName: jdata.cameraOrgName,
              OSD_ip: jdata.ip,
              OSD_port: jdata.port,
              OSD_x: jdata.x,
              OSD_y: jdata.y,
              OSD_tunnelOrder: jdata.tunnelOrder,
            });
            nCount++;
          }
        } else {
          _tabledata.push({
            OSD_no: nCount,
            OSD_cameraOrgName: jdata.cameraOrgName,
            OSD_ip: jdata.ip,
            OSD_port: jdata.port,
            OSD_x: jdata.x,
            OSD_y: jdata.y,
            OSD_tunnelOrder: jdata.tunnelOrder,
          });
          nCount++;
        }
      });
      this.queryPaginationTotal = _tabledata.length;
      if (nCurrent == 0 || nCurrent == 1) {
        this.tableQueryData = _tabledata.slice(0, 10);
      } else {
        var startIndex = (nCurrent - 1) * 10;
        this.tableQueryData = _tabledata.slice(startIndex, startIndex + 10);
      }
    }
  }

  private DownloadClick(row) {
    this.downloadDialogVisible = true;
    this.downloadTitle = "下载" + row.dataType;
    this.downloadContent = "确认重新下载【" + row.dataType + "】";
    this.nCurrentBaseDataType = parseInt(row.no);
    this.queryForm = true;
    LogHelper.WriteLog(row);
  }
  private SearchFailRet() {
    this.bigNumDataShow = false;
    this.bigNumDataResult = "查询不到相关记录！";
  }
  private queryPaginationCurrentChange(val) {
    this.SearchData(val);
  }
  //展示打印进度
  public async ShowAsync(index, msg) {
    return new Promise((resolve) => {
      setTimeout(() => {
        // this.oneKeyRepaireTableData[index - 1].result = msg;
        resolve("success");
      }, 300);
    });
  }
  private nSuccessCount = 0;
  private nFailed = 0;
  private RepairAction(index) {
    if (index == 11) {
      this.resultText = "";
      let _resopnse = customRuleSearch(
        this.globalConfig.LocalMac,
        this.globalConfig.CompName,
        this.globalConfig.CurrentDeviceType,
        this.globalConfig.InOutFlag
      );
      let response = _resopnse == null ? null : JSON.parse(_resopnse);

      if (response != null) {
        this.nSuccessCount++;
        this.resultText += "  自定义条码规则下载成功...";
        this.oneKeyRepaireTableData[index - 1].number = response.length;
      } else {
        this.nFailed++;

        this.resultText +=
          "  自定义条码规则下载失败" + "...";
        this.oneKeyRepaireTableData[index - 1].number = 0;
      }
      this.oneKeyRepaireTableData[index - 1].result = this.resultText;
    } else if (index == 12) {
      this.resultText = "";
      let response = JSON.parse(osdInfoDownLoad(""));
      if (response != null && response.data?.count > 0) {
        this.nSuccessCount++;
        this.resultText += "  OSD信息下载成功...";
        this.oneKeyRepaireTableData[index - 1].number = response.data.count;
      } else {
        this.nFailed++;

        this.resultText +=
          "  OSD信息下载失败，失败原因：" + response.respMessage + "...";
        this.oneKeyRepaireTableData[index - 1].number = 0;
      }
      this.oneKeyRepaireTableData[index - 1].result = this.resultText;
    } else {
      this.resultText = "";
      let request: any = {};
      request.devMac = this.globalConfig.LocalMac;
      request.devType = "0";
      request.body = {
        queryValue: "1",
        queryType: "25",
        viewType: "2",
        extend1: index.toString(),
        extend2: "",
        extend3: "",
      };
      var response = JSON.parse(uploadBaseData(JSON.stringify(request)));
      debugger;
      if (response.respcode != "000") {
        this.nFailed++;
        switch (index) {
          case 1:
            this.resultText +=
              "  条码规则下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 2:
            this.resultText +=
              "  大号段下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 3:
            this.resultText +=
              "  特殊不校验规则下载失败，失败原因：" +
              response.respMessage +
              "...";
            break;
          case 4:
            this.resultText +=
              "  业务规则下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 5:
            this.resultText +=
              "  组织建包规则下载失败，失败原因：" +
              response.respMessage +
              "...";
            break;
          case 6:
            this.resultText +=
              "  员工下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 7:
            this.resultText +=
              "  网点/中心(组织)下载失败，失败原因：" +
              response.respMessage +
              "...";
            break;
          case 8:
            this.resultText +=
              "  线路下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 9:
            this.resultText +=
              "  问题件大类下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 10:
            this.resultText +=
              "  问题件小类下载失败，失败原因：" + response.respMessage + "...";
            break;
          case 11:
            this.resultText +=
              "  自定义条码规则下载失败，失败原因：" +
              response.respMessage +
              "...";
          case 12:
            this.resultText +=
              "  OSD信息下载失败，失败原因：" + response.respMessage + "...";
            break;
        }
        this.oneKeyRepaireTableData[index - 1].number = 0;
        this.oneKeyRepaireTableData[index - 1].result = this.resultText;
        // this.ShowAsync(index,this.resultText);
        LogHelper.WriteLog("下载失败" + response.respMessage);
      } else {
        if (response.data != null) {
          let obj = response.data.busiDataArray;
          let sRet = obj;
          sRet = index === 5 ? response.data.count : sRet[0];
          // dicRet.Add(index, parseInt(sRet));
          // this.dicRet.push({ index: index, number: parseInt(sRet) });
          this.oneKeyRepaireTableData[index - 1].number = parseInt(sRet);
        } else {
          // dicRet.Add(index, 0);
          // this.dicRet.push({ index: index, number: parseInt("0") });
          this.oneKeyRepaireTableData[index - 1].number = 0;
        }

        this.nSuccessCount++;
        // nEnd = this.resultText.length;
        switch (index) {
          case 1:
            this.resultText += "  条码规则下载成功...";
            /***********************add by klm 2022-11-16****************************/
            if (typeof obj_Basedataupload !== "undefined") {
              obj_Basedataupload.reDownloadCodeRuleAbout();
            }
            /***********************************************************************/
            break;
          case 2:
            this.resultText += "  大号段下载成功...";
            break;
          case 3:
            this.resultText += "  特殊不校验规则下载成功 ...";
            break;
          case 4:
            this.resultText += "  业务规则下载成功 ...";
            break;
          case 5:
            this.resultText += "  组织建包规则下载成功 ...";
            break;
          case 6:
            this.resultText += "  员工下载成功...";
            break;
          case 7:
            this.resultText += "  网点/中心(组织)下载成功 ...";
            break;
          case 8:
            this.resultText += "  线路下载成功...";
            break;
          case 9:
            this.resultText += "  问题件大类下载成功...";
            break;
          case 10:
            this.resultText += "  问题件小类下载成功...";
            break;
          case 11:
            this.resultText += "  自定义条码规则下载成功...";
          case 12:
            this.resultText += "  OSD信息下载成功...";
            break;
        }

        this.oneKeyRepaireTableData[index - 1].result = this.resultText;
        // this.ShowAsync(index,this.resultText);
        // richTextBox1.Select(nEnd, this.richTextBox1.Text.Length - nEnd);
        // richTextBox1.SelectionColor = Color.Black;
        // this.resultText += "\r\n";
        if (response.data != null) {
        }
        return this.resultText;
      }
    }
  }
  private async OneClickRepair() {
    LogHelper.WriteLog("一键修复");
    debugger;
    this.nSuccessCount = 0;
    this.nFailed = 0;
    // let nStart = 0,
    // nEnd = 0;
    // for (let index = 1; index <= 10; index++) {
    for (let index = 1; index <= 12; index++) {
      this.RepairAction(index);
      await this.ShowAsync(index, "");
    }
    // this.resultText +=
    if (this.nFailed == 0) {
      this.oneKeyRepaireState =
        "  共12条下载项，" + this.nFailed.toString() + "项下载失败";
    } else {
      this.oneKeyRepaireState =
        "  共12条下载项，" +
        '<span style="color:Red;">' +
        this.nFailed.toString() +
        "</span>" +
        "项下载失败";
    }

    this.oneKeyRepaireTableData.forEach((item) => {
      if (this.tableData.some((_item) => _item.no == item.no)) {
        let _tableDataItem = this.tableData.filter(
          (_item) => _item.no == item.no
        )[0];
        _tableDataItem.downloadedNum = item.number;
        _tableDataItem.lastestDownloadTime = dayjs().format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
    });

    //this.richTextBox1.AppendText("\r\n");

    // this.btnOK.Text = "确定";
    // this.btnOK.Enabled = true;
    // bIsEndOneRepair = true;
  }
  private DownloadConfirm() {
    debugger;
    if (this.nCurrentBaseDataType == 0) {
      LogHelper.WriteLog("其他页面触发一键修复,请检查逻辑");
    } else {
      this.downloadState = "准备下载";
      this.queryForm = false;
      let num: number = 0;
      this.progressValue = 0; //进度条的值
      let i = 6 - 1; //因为满足条件之后num++还会执行一次，pro的值会超过100，所以这里减1处理下
      this.timer = setInterval(() => {
        this.downloadState = "下载中";
        if (num === i) {
          clearInterval(this.timer);
          this.timer = null;
          LogHelper.WriteLog("自动销毁定时器");
        }
        LogHelper.WriteLog("定时器执行" + num.toString());

        num++;
        this.progressValue = parseInt(((num / 6) * 100 - 1).toString());
      }, 1000);
      setTimeout(() => {
        this.UploadData().then(() => {
          if (this.timer != null) {
            clearInterval(this.timer);
            this.timer = null;
            LogHelper.WriteLog("手动销毁定时器");
          }
          if (this.bIsEndUpload) {
            this.progressValue = 100;
            this.downloadState = "下载完成！";
            let first = this.tableData.filter(
              (item) => item.no == this.nCurrentBaseDataType
            )[0];
            first.lastestDownloadTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
            first.downloadedNum = this.bValue;
          }
          if (!this.bIsSuccess) {
            this.progressValue = 0;
            this.downloadState = "下载失败！";
          }
        });
      }, 3000);
    }
  }
  private async UploadData() {
    debugger;
    if (this.nCurrentBaseDataType != 0) {
      if (this.nCurrentBaseDataType == 11) {
        //11、自定义拦截规则
        let _resopnse = customRuleSearch(
          this.globalConfig.LocalMac,
          this.globalConfig.CompName,
          this.globalConfig.CurrentDeviceType,
          this.globalConfig.InOutFlag
        );
        let response = _resopnse == null ? null : JSON.parse(_resopnse);
        if (response != null) {
          this.bValue = response.length;
          this.bIsSuccess = true;
          this.bIsEndUpload = true;
        } else {
          this.bIsSuccess = false;
          LogHelper.WriteLog("下载失败");
        }
      } else if (this.nCurrentBaseDataType == 12) {
        //12、OSD
        this.resultText = "";
        let response = JSON.parse(osdInfoDownLoad(""));
        if (response != null) {
          this.bValue = response.data.count;
          this.bIsSuccess = true;
          this.bIsEndUpload = true;
        } else {
          this.bIsSuccess = false;
          LogHelper.WriteLog("下载失败" + response.respMessage);
        }
      } else {
        let request = {
          devMac: this.globalConfig.LocalMac,
          devType: "0",
          body: {
            queryValue: "1",
            queryType: "25",
            viewType: "2",
            extend1: this.nCurrentBaseDataType.toString(),
            extend2: "",
            extend3: "",
          },
        };
        debugger;
        var response = JSON.parse(uploadBaseData(JSON.stringify(request)));
        if (response.respcode != "000") {
          this.bIsSuccess = false;
          LogHelper.WriteLog("下载失败" + response.respMessage);
        } else {
          /***********************add by klm 2022-11-16****************************/
          debugger;
          if (
            this.nCurrentBaseDataType == 1 &&
            typeof obj_Basedataupload !== "undefined"
          ) {
            obj_Basedataupload.reDownloadCodeRuleAbout();
          }
          /***********************************************************************/

          if (response.data != null) {
            debugger;
            try {
              if (this.nCurrentBaseDataType.toString() == "5")
              {
                this.bValue = response.data.count;
                this.setIsNewBagRules();
              }
              else
              {
                this.bValue = response.data.busiDataArray[0];
              }
            } catch (error) {
              LogHelper.Error(error);
            }

            //     Object obj = response.data.busiDataArray;
            //     string sRet = Convert.ToString(obj);
            //     sRet = CleanString(sRet.Trim()).Replace("[", "").Replace("]", "");
            //     _temp = sRet;
            //     /*JObject jsData = (JObject)response.data.busiDataArray;
            //     string str = CleanString(jsData["records"].ToString());
            //     JArray jArray = JArray.Parse(str);
            //     string strLatestDownloadTime = "", strDownloadCount = "";
            //     foreach (var item in jArray)
            //     {
            //         DataGridViewRow row = new DataGridViewRow();
            //         JObject jdata = (JObject)item;
            //         if (jdata.Property("latestDownloadTime") != null)
            //         {
            //             strLatestDownloadTime = jdata["latestDownloadTime"].ToString();
            //         }
            //         if (jdata.Property("downloadCount") != null)
            //         {
            //             strDownloadCount = jdata["downloadCount"].ToString();
            //         }
            //     }*/
          }
          this.bIsSuccess = true;
          this.bIsEndUpload = true;
        }
      }
    } else {
      /*InitRepairInterface()*/
    }
  }
  private discountHeaderStyle({ row, column, rowIndex, columnIndex }) {
    if (rowIndex === 1) {
      //隐藏另外领两个头部单元格
      return { display: "none" };
    }
  }
}
